export default __webpack_public_path__ + "static/media/London.07d37fe7.jpg";